enum MarginStatus {
	MarginValidated = "MarginValidated",
	MarginNotYetDeterminable = "MarginNotYetDeterminable",
	MarginToBeInvestigated = "MarginToBeInvestigated"
}

export default MarginStatus;
